/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostCounselingValidateResponseTypename = "PostCounselingValidateResponse" as const;

/**
 *
 * @export
 * @interface PostCounselingValidateResponse
 */
export interface PostCounselingValidateResponse {
  /**
   *
   * @type {boolean}
   * @memberof PostCounselingValidateResponse
   */
  valid?: boolean;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostCounselingValidateResponse
   */
  readonly __typename?: string;
}

export function PostCounselingValidateResponseFromJSON(json: any): PostCounselingValidateResponse {
  return PostCounselingValidateResponseFromJSONTyped(json, false);
}

export function PostCounselingValidateResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostCounselingValidateResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostCounselingValidateResponseTypename,

    valid: !exists(json, "valid") ? undefined : json["valid"],
  };
}

export function PostCounselingValidateResponseToJSON(object?: PostCounselingValidateResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    valid: value.valid,
  };
}
